const all = (...funs) => (arg) => funs.every((fun) => fun(arg));

export default all;
